import React, { Component } from "react"
import { Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import {
  Container,
  Tabs,
  Tab,
  TextField,
  Box,
  Button,
  Hidden,
  Fab,
  Menu,
  MenuItem,
  Icon,
  IconButton,
} from "@material-ui/core"
import MainAppBar from "../../components/MainAppBar"
import TabBar from "../../components/TabBar"
import ParentTable from "./Tables/parent"
import ChildTable from "./Tables/child"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import ParentRoleDiloag from "./parentRoleDialog"
import { getParentChildRoles, deleteParentRole } from "../../actions/roles"
import AddIcon from "@material-ui/icons/Add"
import { openSnackBar } from "../../actions/snack-bar"
import CrewMamaAppBarComponent from "../../components/CrewmamaAppBar"
import { getCurrentHost } from "../../utils/getHost"
import { isEmpty } from "lodash"
import CircularProgress from "@material-ui/core/CircularProgress"

class Roles extends Component {
  state = {
    tab: 0,
    parentDialogOpen: false,
    apiData: {},
    editRole: null,
    roles: [],
    filteredRoles: [],
    searchValue: "",
    filteredChildRoles: [],
    searchMenuAnchorEl: null,
  }
  componentDidMount() {
    this.loadData()
  }
  loadData = () => {
    return this.props.dispatch(getParentChildRoles()).then(res => {
      this.setState({ apiData: res })
      const parents = res.parents.map(x => ({ ...x, type: "parent" })).concat(
        res.connections.map(x => ({
          ...res.children.find(y => x.child_role_id === y.id),
          parent_role_id: x.parent_role_id,
          type: "child",
        }))
      )
      const children = res.children.map(x => {
        return {
          ...x,
          parents: res.connections
            .filter(y => x.id === y.child_role_id)
            .map(x => {
              const parent = res.parents.find(y => x.parent_role_id === y.id)
              return (parent && parent.name) || ""
            })
            .toString(),
        }
      })
      this.setState({
        roles: parents,
        filteredRoles: parents,
        childRoles: children,
        filteredChildroles: children,
      })
    })
  }

  setEditRole = role => {
    this.setState({
      editRole: role,
    })
  }
  setParentDialogOpen = bool => {
    this.setState({
      parentDialogOpen: bool,
    })
  }

  searchParentRole = value => {
    const { roles, apiData } = this.state
    this.setState({ searchValue: value })
    if (apiData && apiData.connections && roles && roles.length > 0) {
      const parents = roles.filter(
        x =>
          x &&
          x.type === "parent" &&
          x.name.toUpperCase().includes(value.toUpperCase())
      )
      const children = apiData.connections
        .filter(x => parents.find(y => y.id === x.parent_role_id))
        .map(conn => {
          return {
            ...apiData.children.find(x => x.id === conn.child_role_id),
            parent_role_id: conn.parent_role_id,
            type: "child",
          }
        })

      const newRoles = parents.concat(children)
      this.setState({ filteredRoles: newRoles })
    }
  }

  searchChildrole = value => {
    const { roles, apiData, childRoles } = this.state
    this.setState({ searchValue: value })
    if (apiData && apiData.connections && roles && roles.length > 0) {
      const children = childRoles.filter(
        x => x && x.name && x.name.toUpperCase().includes(value.toUpperCase())
      )
      const newRoles = children
      this.setState({ filteredChildroles: newRoles })
    }
  }

  handleOpenSearchMenu = event => {
    this.setState({
      searchMenuAnchorEl: event.currentTarget,
    })
  }
  handleCloseSearchMenu = () => {
    this.setState({
      searchMenuAnchorEl: null,
    })
  }

  handleDeleteParent = async id => {
    const response = await this.props.dispatch(deleteParentRole(id))
    if (
      response &&
      response.message &&
      response.message === "parent role created"
    ) {
      this.loadData()
      this.props.dispatch(openSnackBar({ message: "Parent role deleted" }))
    } else {
      this.props.dispatch(
        openSnackBar({ message: "Error deleting parent role" })
      )
    }

    // console.log("response", response)
    // // .then(this.loadData())
    // // .catch(err => {
    // //   console.log(err)
    // //   this.props.dispatch(openSnackBar({ message: "Error deleting parent role" }))
    // // })
  }

  render() {
    const {
      apiData,
      parentDialogOpen,
      editRole,
      filteredRoles,
      searchValue,
      roles,
      filteredChildroles,
      searchMenuAnchorEl,
    } = this.state
    const { history, classes } = this.props
    return (
      <Fragment>
        {getCurrentHost() === "crewmama" ? (
          <CrewMamaAppBarComponent history={history} />
        ) : (
          <Fragment>
            <MainAppBar />
            <TabBar history={history} />
          </Fragment>
        )}
        <Container
          style={{
            maxWidth: "100%",
            backgroundColor: "#f8f8f8",
            paddingTop: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "16px",
            }}
          >
            {/* WEB VIEW */}
            <Hidden smDown>
              <Fragment>
                <Button
                  onClick={() => {
                    this.setParentDialogOpen(true)
                    this.setEditRole({})
                  }}
                  color="primary"
                  variant="contained"
                >
                  + New Parent Role
                </Button>
              </Fragment>
            </Hidden>

            <div className={classes.tabContainer}>
              <Tabs
                value={this.state.tab}
                onChange={(_e, newTabVal) => this.setState({ tab: newTabVal })}
                TabIndicatorProps={{ style: { background: "#5241a3" } }}
                style={{ marginRight: "10px" }}
              >
                <Tab
                  label={
                    <span
                      className={
                        this.state.tab === 0
                          ? classes.activeTab
                          : classes.customStyleOnTab
                      }
                    >
                      Parents
                    </span>
                  }
                />
                <Tab
                  label={
                    <span
                      className={
                        this.state.tab === 0
                          ? classes.customStyleOnTab
                          : classes.activeTab
                      }
                    >
                      Childs
                    </span>
                  }
                />
              </Tabs>

              {/* WEB VIEW */}
              <Hidden smDown>
                <Box style={{ width: "200px" }}>
                  <TextField
                    value={searchValue}
                    onChange={e =>
                      this.state.tab === 0
                        ? this.searchParentRole(e.target.value)
                        : this.searchChildrole(e.target.value)
                    }
                    label="Search Name"
                  />
                </Box>
              </Hidden>

              {/* MOBILE VIEW */}
              <Hidden mdUp>
                <IconButton onClick={e => this.handleOpenSearchMenu(e)}>
                  <Icon>search</Icon>
                </IconButton>
                <Menu
                  anchorEl={searchMenuAnchorEl}
                  open={Boolean(searchMenuAnchorEl)}
                  onClose={() => this.handleCloseSearchMenu()}
                  getContentAnchorEl={null}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <MenuItem>
                    <TextField
                      value={searchValue}
                      onChange={e =>
                        this.state.tab === 0
                          ? this.searchParentRole(e.target.value)
                          : this.searchChildrole(e.target.value)
                      }
                      label="ful_name"
                    />
                  </MenuItem>
                </Menu>
              </Hidden>
            </div>
          </div>
          {!isEmpty(filteredRoles) ? (
            <Fragment>
              {this.state.tab === 0 ? (
                <ParentTable
                  props={this.props}
                  roles={roles}
                  classes={this.props.classes}
                  apiData={apiData}
                  dialogOpen={parentDialogOpen}
                  filteredRoles={filteredRoles}
                  editRole={editRole}
                  setEditRole={role => this.setEditRole(role)}
                  setDialogOpen={bool => this.setParentDialogOpen(bool)}
                  loadData={() => this.loadData}
                  deleteParent={id => this.handleDeleteParent(id)}
                />
              ) : (
                <ChildTable
                  classes={this.props.classes}
                  filteredRoles={filteredChildroles}
                  loadData={() => this.loadData()}
                />
              )}
            </Fragment>
          ) : (
            <CircularProgress style={{ margin: "100px" }} />
          )}
        </Container>
        <ParentRoleDiloag
          open={parentDialogOpen}
          currentRole={editRole}
          apiData={apiData}
          onClose={bool => {
            if (bool) {
              this.loadData()
            }
            this.setEditRole(null)
            this.setParentDialogOpen(false)
          }}
        />
        {/* MOBILE VIEW */}
        <Hidden mdUp>
          <Fab
            color="primary"
            className={classes.legendButton}
            onClick={() => {
              this.setParentDialogOpen(true)
              this.setEditRole({})
            }}
          >
            <AddIcon style={{ color: "white" }} />
          </Fab>
        </Hidden>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
    activeCompany: state.companies.activeCompany,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
  // withStyles(styles, { withTheme: true })
)(Roles)
